module.exports = __webpack_public_path__ + "media/images/prediction/special/nagai/bg_nagaitop-143d9112e3cd96d817b584c587856ac2.jpg";